/**
 * Encodes a JavaScript object into a base64 encoded JSON string.
 * @param value - The JavaScript object to encode.
 * @returns The base64 encoded JSON string or null if encoding fails or value is not valid.
 */
export const encodeValue = (value: unknown) => {
  if (value == null) return null;
  if (Array.isArray(value) && value.length === 0) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  try {
    JSON.stringify(value); // Verificar si es stringifiable
    return btoa(JSON.stringify(value));
  } catch {
    return null;
  }
};

/**
 * Decodes a base64 encoded JSON string into a JavaScript object.
 * @param encodedValue - The base64 encoded JSON string.
 * @returns The decoded JavaScript object or null if decoding fails.
 */
export const decodeValue = <T>(encodedValue: string | null) => {
  if (!encodedValue) return null;
  try {
    return JSON.parse(atob(encodedValue)) as T;
  } catch {
    return null;
  }
};
